import { BaseModel } from '@Core';
import { PTZCameraConfigs } from './PTZCameraConfigs';

export interface PTZCamera extends BaseModel {
    Mac: string;
    PatrolMode: PTZPatrolMode;
    LastPTZCameraConfigId?: number;
    PTZCameraConfig?: PTZCameraConfigs;
    LastContact?: Date;
}

export enum PTZPatrolMode {
    FullPatrol,
    VehicleOnlyPatrol
}
